export default __webpack_public_path__ + "media/images/Contact_Card-bafb3a9bbbe9eec381cd8193b41dfc06.png";